import Seo from "../../components/Seo";
import PricingCards from "../../components/marketing/PricingCards";
import { usePublicPlans } from "../../hooks/usePublicPlans";
import "./Pricing.css";

const Pricing = () => {
  const { plans, loading, error, reload } = usePublicPlans();

  return (
    <div className="pricing-page">
      <Seo
        title="Pricing — Carely IT"
        description="Simple plans for growing organizations. Every plan includes onboarding and support — we'll activate it together."
        canonicalPath="/pricing"
      />
      <header className="pricing-page__header">
        <p className="pricing-page__eyebrow">Pricing</p>
        <h1 className="pricing-page__title">
          Simple plans for growing organizations
        </h1>
        <p className="pricing-page__lead">
          Every plan includes onboarding and support. Choose the fit for your
          organization — we'll activate it together.
        </p>
      </header>

      <PricingCards
        plans={plans}
        loading={loading}
        error={error}
        onRetry={reload}
      />

      <p className="pricing-page__note">
        Plans are activated after onboarding. No self-serve registration —
        call <a href="tel:01916707697">01916707697</a> or email{" "}
        <a href="mailto:zonayed@carelyit.com">zonayed@carelyit.com</a> and
        we'll set up your organization with you.
      </p>
    </div>
  );
};

export default Pricing;
